<template>
  <!-- 关于 -->
  <div class="ygPurchaseAndSale">
    <!-- 顶部背景图 -->
    <div class="ygPurchaseAndSale-top">阳光购销平台</div>
    <!-- 数据表格 -->
    <div class="dataTable">
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2">
          <div style="margin: 15px 0px; text-align: left">
            <el-radio-group v-model="resources_radio" @change="resourcesChange">
              <el-radio label="1" border size="medium">再生资源</el-radio>
              <el-radio label="2" border size="medium">废钢</el-radio>
              <el-radio label="3" border size="medium">废铁</el-radio>
              <el-radio label="4" border size="medium">废纸</el-radio>
            </el-radio-group>
          </div>
          <div style="margin: 15px 0px; text-align: left">
            <el-radio-group v-model="sand_radio" @change="sandChange">
              <el-radio label="1" border size="medium">建材砂石</el-radio>
              <el-radio label="2" border size="medium">煤矿石</el-radio>
              <el-radio label="3" border size="medium">石英砂</el-radio>
              <el-radio label="4" border size="medium">石灰石</el-radio>
            </el-radio-group>
          </div>
          <el-table
            :data="dataList"
            border
            style="width: 100%"
            height="588"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.7)"
          >
            <el-table-column label="序号" width="70px">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="categoryName" label="品名" width="150">
            </el-table-column>
            <el-table-column prop="specName" label="规格"> </el-table-column>
            <el-table-column prop="materialName" label="材质" width="150">
            </el-table-column>
            <el-table-column prop="factoryName" label="钢厂" width="150">
            </el-table-column>
            <el-table-column prop="areaName" label="交货地"> </el-table-column>
            <el-table-column prop="warehouseName" label="仓库" width="150">
            </el-table-column>
            <el-table-column prop="num" label="数量"> </el-table-column>
            <el-table-column prop="averageQty" label="件重/吨"> </el-table-column>
            <el-table-column prop="qty" label="重量/吨"> </el-table-column>
            <el-table-column prop="price" label="价格"> </el-table-column>
            <el-table-column label="联系人信息">
              <template slot-scope="scope">
                <el-popover placement="top-start" trigger="hover">
                  <div>
                    <p>姓名：{{ scope.row.adminName }}</p>
                    <!-- <p>电话：{{ scope.row.adminPhone }}</p> -->
                    <p>手机：{{ scope.row.adminMobile }}</p>
                  </div>
                  <img
                    slot="reference"
                    src="../../assets/ygPurchaseAndSale/contacts_chat.png"
                    alt=""
                    style="width: 30px; height: 30px; display: blocb; margin: auto"
                  />
                </el-popover>
              </template>
            </el-table-column>
          </el-table>

          <div style="text-align: right; margin-top: 10px">
            <el-pagination
              background
              @current-change="currentChange"
              :current-page="currentPage"
              :page-size="pagesize"
              :pager-count="5"
              layout="total, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <div class="div0 div6"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ygPurchaseAndSale",
  data() {
    return {
      resources_radio: "1",
      sand_radio: "1",
      loading: true,
      total: 0, //总条数
      currentPage: 1, //当前页码
      pagesize: 10, //每页的数据条数
      dataList: [
        {
          id: 69,
          categoryName: "三级螺纹钢",
          specName: "10*9",
          materialName: "HRB400打劫啊接化发就开始多喝水大家好",
          factoryName: "江苏鸿泰",
          areaName: "丹阳",
          warehouseName: "江苏鸿泰厂提",
          num: 10000,
          averageQty: "1.999",
          qty: "19990",
          price: "4420",
          adminName: "王晓勤",
          adminMobile: "13338619993",
          adminPhone: "025-58721135",
          suiyi: require("../../assets/homePage/ptzc-mys.png"),
        },
      ],
    };
  },
  created() {
    this.waybillList();
  },
  methods: {
    waybillList() {
      // this.loading=true
      this.$api
        .sunshineList({ pageSize: this.pagesize, pageNum: this.currentPage })
        .then((res) => {
          this.loading = false;
          res.list.forEach((e) => {
            console.log(e.adminName);
            var lenMobile = e.adminMobile.length;
            if (lenMobile && lenMobile > 4) {
              e.adminMobile =
                e.adminMobile.substring(0, 3) +
                "****" +
                e.adminMobile.substring(lenMobile - 4, lenMobile);
            }
            var lenName = e.adminName.length;
            if (lenName && lenName > 1 && lenName == 2) {
              e.adminName = e.adminName.substring(0, 1) + "*";
            } else if (lenName && lenName > 2) {
              e.adminName =
                e.adminName.substring(0, 1) +
                "*" +
                e.adminName.substring(lenName - 1, lenName);
            }
          });
          console.log(res, "shuju");
          this.total = res.total;
          this.dataList = res.list;
        });
    },
    //再生资源
    resourcesChange(val) {
      this.dataList=[]
      this.waybillList();
    },
    //建材砂石
    sandChange(val) {
      this.dataList=[]
      this.waybillList();
    },
    currentChange(val) {
      this.currentPage = val;
      this.waybillList();
    },
  },
};
</script>

<style lang="scss" scoped>
.dataTable {
  padding: 50px 0px;
  background: #f5f7fa;
}
.dataTable > .div {
  display: flex;
  justify-content: space-between;
}

.dataTable > .div .div1,
.dataTable > .div .div6 {
  flex: 1;
}
.dataTable > .div .div2 {
  width: 86%;
  /deep/.el-radio__input {
    display: none;
  }
  /deep/.el-radio--medium.is-bordered {
    width: 100px;
    text-align: center;
  }
}
.ygPurchaseAndSale {
  position: relative;
  height: 100%;
  background: #ffffff;

  .ygPurchaseAndSale-top {
    background: url("../../assets/ygPurchaseAndSale/banner.png") center center no-repeat;
    height: 662px;
    line-height: 662px;
    color: #fff;
    font-size: 56px;
  }
  /deep/.el-table td,
  /deep/.el-table th {
    text-align: center;
    color: #515a6e;
  }
  /deep/.el-table th {
    background: #f8f8f9;
  }
}
</style>
